import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '@/lib/utils';
import { getBreadcrumbs } from '@/config/navigation';

interface BreadcrumbsProps {
  currentPath: string;
  onNavigate: (path: string) => void;
  className?: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  currentPath,
  onNavigate,
  className,
}) => {
  const breadcrumbs = getBreadcrumbs(currentPath);

  return (
    <nav
      aria-label="Breadcrumb"
      className={cn('flex items-center space-x-1 text-sm text-muted-foreground', className)}
    >
      {/* Homepage - Always the starting point */}
      <button
        onClick={() => onNavigate('/dashboard')}
        className={cn(
          'flex items-center gap-1.5 transition-colors',
          breadcrumbs.length === 0
            ? 'text-foreground font-medium cursor-default'
            : 'hover:text-foreground cursor-pointer'
        )}
        disabled={breadcrumbs.length === 0}
        aria-label="Homepage"
      >
        <Home className="h-4 w-4" />
        <span>Homepage</span>
      </button>

      {breadcrumbs.map((item, index) => {
        const isLast = index === breadcrumbs.length - 1;
        const Icon = item.icon;

        return (
          <React.Fragment key={item.id}>
            <ChevronRight className="h-4 w-4" />
            <button
              onClick={() => item.path && onNavigate(item.path)}
              disabled={!item.path || isLast}
              className={cn(
                'flex items-center gap-1.5 transition-colors',
                isLast
                  ? 'text-foreground font-medium cursor-default'
                  : 'hover:text-foreground cursor-pointer',
                !item.path && 'cursor-default'
              )}
            >
              {Icon && <Icon className="h-4 w-4" />}
              <span>{item.label}</span>
            </button>
          </React.Fragment>
        );
      })}
    </nav>
  );
};
